import React from 'react';
import PropTypes from 'prop-types';

const NavigationIcon = (size, { title, element }) => (
  <svg
    focusable="false"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    aria-hidden="true"
    tabIndex="-1"
    title={title}
  >
    { element }
  </svg>
);

const ArrowLeftIcon = ({ fillColor, size }) => NavigationIcon(size, {
  title: 'ArrowLeft',
  element: (
    <path
      d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
      fill={fillColor}
    />
  ),
});

const ArrowRightIcon = ({ fillColor, size }) => NavigationIcon(size, {
  title: 'ArrowRight',
  element: (
    <path
      d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
      fill={fillColor}
    />
  ),
});

const DotNavigationIcon = ({ fillColor, size }) => NavigationIcon(size, {
  title: 'NavigationDot',
  element: (
    <circle
      cx="12"
      cy="12"
      r="12"
      fill={fillColor}
    />
  ),
});

const propTypes = {
  fillColor: PropTypes.string,
  size: PropTypes.string,
};

const defaultProps = {
  fillColor: 'var(--grey-dark)',
  size: '24',
};

ArrowLeftIcon.propTypes = propTypes;
ArrowRightIcon.propTypes = propTypes;
DotNavigationIcon.propTypes = propTypes;

ArrowLeftIcon.defaultProps = defaultProps;
ArrowRightIcon.defaultProps = defaultProps;
DotNavigationIcon.defaultProps = defaultProps;

export {
  ArrowLeftIcon,
  ArrowRightIcon,
  DotNavigationIcon,
};
